import { useState } from "react";
import { faqItems } from "@/mocks/gossipData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
            <i className="ri-chat-smile-3-fill text-primary-600"></i>
            常见问题
          </span>
          <h2 className="mt-2 font-display text-3xl md:text-4xl text-foreground-950">你可能想知道的</h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={idx}
                className={`rounded-2xl overflow-hidden transition-colors ${open ? "bg-background-50 ring-1 ring-primary-200" : "bg-background-50 ring-1 ring-background-200"}`}
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 md:px-6 py-4 text-left"
                >
                  <span className="text-[15px] md:text-base font-semibold text-foreground-950">{item.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${open ? "bg-primary-500 text-background-50 rotate-180" : "bg-background-200 text-foreground-600"}`}>
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-6 pb-5 text-sm md:text-base leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* FAQPage structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqItems.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      ></script>
    </section>
  );
}